import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height", "innerHTML"]

import datas from './bx-raw.json'
import { PropType, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  icon: {
    type: Object as PropType<string>,
    required: true
  },
  size: {
    type: Object as PropType<number>,
    required: false,
  }
},
  setup(__props) {

const props = __props


const icon_name = ref(props.icon)
const size = ref(props.size || 20)
const icon_obj = datas.icons
watch(() => props.icon, (item)=> {
  icon_name.value = item
})


return (_ctx: any,_cache: any) => {
  return (_unref(icon_obj)[icon_name.value])
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        class: "kl_icon",
        viewBox: "0 0 24 24",
        width: size.value,
        height: size.value,
        innerHTML: _unref(icon_obj)[icon_name.value].body
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})